






import { Component, Prop, Vue } from 'vue-property-decorator';

interface ColConfig {
  span?: number
}

@Component({
  name: 'mcCol'
})
export default class extends Vue {
  @Prop({ default: () => [] }) private config!: ColConfig;
}
